/**
 * Entry de la página `/notams.html` — Fase 10a.1.
 *
 * Tablón NOTAM del escuadrón: hoja oficial central + post-its colgados
 * en el corcho. Iteración 1: render read-only. La creación, edición y
 * drag&drop de post-its llegan en 10a.2.
 */

import { mountNotams } from './modules/notams/index.js';

void mountNotams();
